export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = 'f5db5993-5374-4cd9-8c39-b1bb90bb73a1';
export const MODAL_CLOSE_SEC = 2.5;
